// extracted by mini-css-extract-plugin
module.exports = {"page":"auth-shell_page__EP1k7","content":"auth-shell_content__RXdQ2"};